"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var classnames_1 = __importDefault(require("classnames"));
var odc_meta_1 = __importDefault(require("@tencent/odc-meta"));
var odc_meta_content_1 = __importDefault(require("@tencent/odc-meta-content"));
var SwitchGroup_1 = __importDefault(require("./SwitchGroup"));
var MetaSwitchPanel = function MetaSwitchPanel(props) {
  var expandClassName = props.expandClassName,
    expandStyle = props.expandStyle,
    // @deprecated 请使用 style 属性
    metaStyle = props.metaStyle,
    alignment = props.alignment,
    Label = props.Label,
    // eslint-disable-line
    label = props.label,
    // eslint-disable-line
    switchLabel = props.switchLabel,
    _a = props.checkedLabel,
    checkedLabel = _a === void 0 ? '开启' : _a,
    _b = props.unCheckedLabel,
    unCheckedLabel = _b === void 0 ? '未开启' : _b,
    children = props.children,
    _c = props.alwayUseChildren,
    alwayUseChildren = _c === void 0 ? false : _c,
    _d = props.onChange,
    onChange = _d === void 0 ? void 0 : _d,
    _e = props.checked,
    checked = _e === void 0 ? false : _e,
    _f = props.disabled,
    disabled = _f === void 0 ? false : _f,
    _g = props.switchTip,
    switchTip = _g === void 0 ? '' : _g,
    _h = props.checkedTips,
    checkedTips = _h === void 0 ? '' : _h,
    // @deprecated 请使用 switchProps 属性
    _j = props.SwitchGroupProps,
    // @deprecated 请使用 switchProps 属性
    SwitchGroupProps = _j === void 0 ? {} : _j,
    // eslint-disable-line
    // 支持自定义开关组件
    _k = props.SwitchComponent,
    // eslint-disable-line
    // 支持自定义开关组件
    SwitchComponent = _k === void 0 ? SwitchGroup_1["default"] : _k,
    // eslint-disable-line
    _l = props.SwitchProps,
    // eslint-disable-line
    SwitchProps = _l === void 0 ? {} : _l,
    // eslint-disable-line
    // 开启后附加
    checkedAddon = props.checkedAddon,
    // 关闭后附加
    uncheckedAddon = props.uncheckedAddon,
    // 常驻附加
    commonAddon = props.commonAddon,
    _m = props.MetaContentWrapper,
    MetaContentWrapper = _m === void 0 ? null : _m,
    // eslint-disable-line
    _o = props.notExpandClassName,
    // eslint-disable-line
    notExpandClassName = _o === void 0 ? false : _o,
    style = props.style;
  var expandComponent;
  var showExpandComponent = true;
  if (checked || alwayUseChildren) {
    expandComponent = children;
  }
  if (alwayUseChildren) {
    showExpandComponent = checked;
  }
  var metaContent = react_1["default"].createElement(odc_meta_content_1["default"], null, react_1["default"].createElement(SwitchComponent, __assign({}, SwitchGroupProps, {
    tips: switchTip,
    disabled: disabled,
    label: switchLabel,
    onChange: onChange,
    checkedLabel: checkedLabel,
    unCheckedLabel: unCheckedLabel,
    checked: checked,
    checkedTips: checkedTips,
    checkedAddon: checkedAddon,
    uncheckedAddon: uncheckedAddon,
    commonAddon: commonAddon
  }, SwitchProps)));
  return react_1["default"].createElement(odc_meta_1["default"], __assign({
    type: "switch"
  }, (0, spaui_utils_1.globalProps)(props, {
    supportAllEvents: true
  }, MetaSwitchPanel), {
    alignment: alignment,
    ExpandComponent: expandComponent,
    showExpandComponent: showExpandComponent,
    expandClassName: (0, classnames_1["default"])('meta-switch-panel', expandClassName),
    expandStyle: expandStyle,
    style: __assign(__assign({}, metaStyle), style),
    notExpandClassName: notExpandClassName
  }), Label || label, MetaContentWrapper ? react_1["default"].createElement(MetaContentWrapper, null, metaContent) : metaContent);
};
(0, spaui_utils_1.setComponentMark)(MetaSwitchPanel, info_1["default"]);
exports["default"] = react_1["default"].memo(MetaSwitchPanel);